// src/utils/permessiDefaultPerRuolo.js
// I 5 ruoli operativi previsti per qualunque azienda che usa Nexiora — Titolare resta un
// livello a parte (vede sempre tutto, non entra in questo elenco). Ogni ruolo può essere
// condiviso da più persone contemporaneamente, e ogni persona può ricevere aggiunte o
// rimozioni individuali sopra la base del proprio ruolo (vedi useCanSee.js).
//
// Questo è anche l'unico posto dove questa mappatura vive — la pagina di documentazione in
// Impostazioni Aziendali (RuoliPermessiInfo) la legge direttamente da qui, così i due non
// possono mai disallinearsi.
export const PERMESSI_DEFAULT_PER_RUOLO = {
  gestione: {
    label: "Gestione aziendale",
    descrizione: "Decisioni operative sull'azienda nel suo complesso — commesse, personale, pianificazione, clienti.",
    sezioni: [
      "tab-tutto", "control-center", "clienti", "impianti", "gestione-impianti", "verifiche-periodiche", "gestione-verifiche", "centro-evoluto",
      "dipendenti", "programmazione", "pianificazione-team", "le-mie-commesse", "scadenziario",
      "suggerimenti-operativi", "cabina-regia", "gestione-contratti-manutenzione",
      "cruscotto-scadenze", "da-fatturare", "elaborazione-offerte", "registro-sal",
      "registro-interventi", "documenti-subappaltatori", "documenti-subappaltatori-verifica", "pratiche", "pratiche-riservati", "sicurezza-cantiere", "moduli-commessa", "ore-commesse", "ditte-esterne",
    ],
  },
  amministrazione: {
    label: "Amministrazione",
    descrizione: "Adempimenti, scadenze legali/fiscali, documenti societari — visure, rinnovi, approvazioni.",
    sezioni: [
      "tab-personale", "tab-gestione", "scadenziario", "approvazione-cartellini",
      "approvazione-note-spese", "approvazione-ferie-permessi", "registro-rapportini", "report-ore", "gestione-contratti-manutenzione",
      "cruscotto-scadenze", "da-fatturare", "registro-sal", "registro-noleggi", "registro-noleggi-chiudi",
      "scadenze-personale", "documenti-subappaltatori", "documenti-subappaltatori-verifica", "pratiche", "pratiche-riservati", "ore-commesse", "ditte-esterne",
    ],
  },
  pm: {
    label: "Project Manager",
    descrizione: "Segue le commesse dall'offerta alla chiusura — vede quasi tutto il lato operativo.",
    sezioni: [
      "tab-tutto", "control-center", "clienti", "centro-evoluto",
      "dipendenti", "programmazione", "pianificazione-team", "le-mie-commesse", "scadenziario",
      "report-ore", "centro-acquisti", "magazzino", "rientro-materiali", "suggerimenti-operativi", "ore-commesse", "ditte-esterne",
      "contratti-manutenzione", "gestione-contratti-manutenzione",
      "cruscotto-scadenze", "elaborazione-offerte", "registro-sal",
      "registro-interventi", "registro-noleggi", "documenti-subappaltatori", "pratiche", "moduli-commessa",
      "sopralluoghi-senza-commessa",
    ],
  },
  magazziniere: {
    label: "Magazziniere",
    descrizione: "Centrato su materiali e magazzino — richieste, acquisti, rientri.",
    sezioni: ["tab-personale", "tab-acquisti", "centro-acquisti", "magazzino", "rientro-materiali", "modifica-acquisti", "modifica-magazzino"],
  },
  operativi: {
    label: "Operativi",
    descrizione: "Accesso minimo, essenziale per lavorare — le sue commesse, presenze, note spese, richieste di materiale.",
    sezioni: ["tab-personale", "tab-progetti", "magazzino", "rientro-materiali"],
  },
};

export const RUOLI_OPERATIVI = Object.entries(PERMESSI_DEFAULT_PER_RUOLO).map(([id, r]) => ({ id, label: r.label, descrizione: r.descrizione }));
